import React from 'react';
import { usePaymentMethodQuery } from 'api';
import { Col, EditableInfoComponent, Row, Typography } from 'components';
import { SpecialRateIcon } from 'components/common/icons/SpecialRateIcon';
import { PAYMENT_TERMS_MAPPING } from 'staticData/form';
import { CURRENCY_MAPPING } from 'feature/dealTabs/commercialOffers/updateCommercialOfffer/paymentTerms';

const { Text } = Typography;

export interface PaymentTermsData {
  paymentTerms: string;
  threshold: string;
  prepayment: string;
  paymentMethodId: string;
  netDaysAfterDelivery: number;
  ccPaymentProcessingFee: string;
  currency: string;
  conversionRate: number;
}

type PaymentTermKey = keyof typeof PAYMENT_TERMS_MAPPING;
type CurrencyKey = keyof typeof CURRENCY_MAPPING;

export const PaymentTerms = React.memo<{ data: PaymentTermsData }>(({ data }) => {
  const {
    paymentTerms,
    threshold,
    prepayment,
    paymentMethodId,
    netDaysAfterDelivery,
    ccPaymentProcessingFee,
    currency,
    conversionRate,
  } = data;
  const { data: paymentMethodData = [] } = usePaymentMethodQuery();

  return (
    <Row>
      <Col span={24}>
        <EditableInfoComponent creatable={false} editable={false} icon={<SpecialRateIcon />} title={'Payment Terms'} />
      </Col>
      <Col span={24}>
        {[
          ['Payment Terms', PAYMENT_TERMS_MAPPING[paymentTerms as PaymentTermKey]],
          ['Threshold', threshold ? `${threshold}€` : null],
          ['Prepayment', prepayment ? `${prepayment}%` : null],
          ['Payment Method', paymentMethodData.find((item: any) => item.value === paymentMethodId)?.label],
          ['Net Days After Delivery', netDaysAfterDelivery ? `${netDaysAfterDelivery}day` : null],
          ['CC Payment Processing Fee', ccPaymentProcessingFee ? `${ccPaymentProcessingFee}%` : null],
          ['Currency', CURRENCY_MAPPING[currency as CurrencyKey]],
          ['Exchange Rate', conversionRate],
        ].map(([label, value]) => (
          <Row justify="space-between" wrap={false} key={label} align={'middle'}>
            <Col span={'auto'}>
              <Text type={'secondary'} className={'font-size-16'}>
                {label}
              </Text>
            </Col>
            <Col flex="0 1 auto">
              <Text
                type={'secondary'}
                className={'font-size-16'}
                style={{ whiteSpace: 'nowrap' }}
                ellipsis={{ tooltip: true }}
              >
                {value || 'Not Set'}
              </Text>
            </Col>
          </Row>
        ))}
      </Col>
    </Row>
  );
});
